export const pendingBookings = {
  configTitle: "Skonfiguruj rezerwacje bezpośrednie",
  configText:
    "Włącz rezerwacje bezpośrednie, aby zarządzać oczekującymi płatnościami i prośbami o rezerwację od gości w tym miejscu.",
  reminderLabel: "Przypomnienie:",
  reminderReasonIntent: "oczekuje płatności, gość:",
  reminderReasonUnassigned: "przypisz pokój, gość:",
  reminderReasonRequest: "prośba do rozpatrzenia, gość:",
  combined: "Połączona · {count} pokoi",
  expired: "Wygasła",
  toastSuccessTitle: "Gotowe",
  toastErrorTitle: "Błąd",
  toastWarningTitle: "Uwaga",
};
